import {Component, Inject, OnInit, signal, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  BaseDialogComponent,
  NodeDaoService,
  REF_MODEL_SF_TYPES,
  SnackBarService
} from '@q9elements/ui-kit/common';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {CreateProposedNodeData} from '../../models/proposed-node.interface';

@Component({
  selector: 'app-create-proposed-node-dialog',
  templateUrl: './create-proposed-node-dialog.component.html',
  styleUrls: ['./create-proposed-node-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateProposedNodeDialogComponent extends BaseDialogComponent implements OnInit {
  public loading = signal(false);
  public proposedNodeType = '';
  public createProposedNodeForm: FormGroup;

  private createdNodes = [];
  private continueAdding = false;

  constructor(
    private fb: FormBuilder,
    private nodeDaoService: NodeDaoService,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: CreateProposedNodeData,
    public dialogRef: MatDialogRef<CreateProposedNodeDialogComponent>
  ) {
    super();
  }

  ngOnInit() {
    this.proposedNodeType = this.data.type.sfType || '';
    this.initForm();
  }

  private initForm() {
    const validators = [Q9Validators.required(), Q9Validators.maxLength(150)];
    const fields = {
      label: ['', validators],
      description: ['', Q9Validators.maxLength(5000)]
    };

    if (this.proposedNodeType !== REF_MODEL_SF_TYPES.DASHBOARD) {
      Object.assign(fields, {
        apiName: [
          '',
          [...validators, Q9Validators.pattern('^[^-]*$', 'CORE.UI_KIT.HYPHEN_NOT_ALLOWED')]
        ]
      });
    }

    this.createProposedNodeForm = this.fb.group(fields);
  }

  override onSubmit(continueAdding: boolean = false) {
    if (this.createProposedNodeForm.invalid) {
      this.createProposedNodeForm.markAllAsTouched();
      this.createProposedNodeForm.markAsDirty();
      return;
    }

    this.continueAdding = continueAdding;
    this.sendSubmitRequest();
  }

  protected override sendSubmitRequest(): Observable<unknown> {
    const {
      parentId,
      type: {id: typeId},
      refModelId
    } = this.data;
    const payload = {...this.createProposedNodeForm.value, parentId, typeId};

    if (payload?.formulaReturnType) {
      payload.fieldType = payload.formulaReturnType;
      delete payload.formulaReturnType;
    }

    this.loading.set(true);
    this.nodeDaoService
      .addProposedNode(refModelId, payload)
      .pipe(
        this.takeUntilComponentDestroy(),
        finalize(() => this.loading.set(false))
      )
      .subscribe(
        newNodeData => {
          this.createdNodes.push(newNodeData);

          if (this.continueAdding) {
            this.createProposedNodeForm.reset();
          } else {
            this.dialogRef.close(this.createdNodes);
          }
        },
        error => this.snackBarService.error(error.error)
      );

    return;
  }

  public closeModal() {
    this.dialogRef.close(this.createdNodes);
  }
}
